import { Controller } from '@hotwired/stimulus';

// FIXME: jquery に依存しない構成に変更
export default class extends Controller {
  static targets = ['list'];

  toggle({ currentTarget }) {
    currentTarget.classList.toggle('is-selected');
    $(this.listTarget).stop().slideToggle();
  }
}
